/**
 * @param category - the category of the banner
 * @returns text - the text of the button in the banner
 * */
export const handleBannerButton = category => {
  let text = ""
  switch (category) {
    case "supplements":
      text = "All Supplements"
      break
    case "meal plans":
      text = "Shop Meal Plans"
      break
    case "workout plans":
      text = "Shop Workouts"
      break
    case "rock your life":
      text = "Shop Rock Your Life"
      break
    case "apparel":
      text = "Shop The Collection"
      break
    case "merchandise":
      text = "Shop Merchandise"
      break
    case "december":
      text = "Shop Now"
      break
    case "bundles":
      text = "Shop Bundles"
      break
    default:
      text = "Shop Now"
      break
  }

  return text
}

/**
 * @param type - whether the location is homepage or not
 * @param country 0 - worldwide or us/uk/canada
 * @returns sliderType - the type of the slider
 * */
export const handleBannerSliderType = (type, country) => {
  let sliderType = ""

  if (type === "homepage" && country.toLowerCase() !== "worldwide") {
    sliderType = "homepage-us"
  }
  if (type === "homepage" && country.toLowerCase() === "worldwide") {
    sliderType = "homepage-worldwide"
  }
  if (type !== "homepage") {
    sliderType = type
  }

  return sliderType
}
